exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-model[data-v-3d4793d6]{width:100%;height:100%;position:absolute;top:0;left:0;min-height:1.5rem;-webkit-box-align:center;-webkit-align-items:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:flex;z-index:99;background-color:#fff}.loading-model img[data-v-3d4793d6]{width:2.5rem;height:2.5rem;display:block;margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d4793d6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/directiveLoading/loading/Loading.vue
// module id = tmM3
// module chunks = 53